module.exports = __webpack_public_path__ + "static/media/Step 2.77139c7a.mp3";